import React from 'react';
import './Navbar.css'; // We'll create this CSS file
import logo from '../logo.png'; // Make sure to place your logo image in the 'src' folder
import { FaFacebookF, FaInstagram, FaLinkedin, FaTelegram, FaTiktok } from 'react-icons/fa';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <img src={logo} alt="Bubbles Early Years School Logo" />
        </div>
        <ul className="nav-menu">
          <li className="nav-item">
            <a href="#home" className="nav-links">
              Home
            </a>
          </li>
          <li className="nav-item">
            <a href="#about" className="nav-links">
              About
            </a>
          </li>
          <li className="nav-item">
            <a href="#contact" className="nav-links">
              Contact
            </a>
          </li>
        </ul>
        <div className="social-links">
          <a href="https://www.facebook.com/share/1DVU9vV5Er/" className="social-link" title="Facebook"><FaFacebookF size={20} /></a>
          <a href="https://www.instagram.com/bubbles_early_years?igsh=dXY3dnFlcTl6ZmZw" className="social-link" title="Instagram"><FaInstagram size={20} /></a>
          <a href="https://t.me/Bubblesearlyyears" className="social-link" title="Telegram"><FaTelegram size={20} /></a>
          <a href="https://www.linkedin.com/in/bubbles-early-years-school-275583386" className="social-link" title="LinkedIn"><FaLinkedin size={20} /></a>
          <a href="https://tiktok.com/@bubbles.early.yea" className="social-link" title="TikTok"><FaTiktok size={20} /></a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;